import React from "react";
import { navigate } from "../App";
import { EXTERNAL_PRODUCT_URLS } from "../data/products";

type Props = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & { slug: string };

// Anchor to a product: external products open their own site in a new tab,
// the rest navigate client-side to /products/<slug>.
export function ProductAnchor({ slug, children, ...rest }: Props) {
  const external = EXTERNAL_PRODUCT_URLS[slug];
  if (external) {
    return (
      <a {...rest} href={external} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );
  }
  const href = `/products/${slug}`;
  return (
    <a {...rest} href={href} onClick={(e) => { e.preventDefault(); navigate(href); }}>
      {children}
    </a>
  );
}
